import { FormField } from '../types/templates';

export function isFieldVisibleInResolution(field: FormField, activeResolutionId: string | undefined): boolean {
  const applicable = field.applicableResolutions;
  if (!applicable || applicable.length === 0) return true;
  if (!activeResolutionId) return true;
  return applicable.includes(activeResolutionId);
}

export function findResolutionForField(fields: readonly FormField[], fieldKey: string): string | undefined {
  const field = fields.find(f => f.key === fieldKey);
  if (!field?.applicableResolutions || field.applicableResolutions.length === 0) return undefined;
  return field.applicableResolutions[0];
}
